import { Building2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

type DiscoveredOrganization = {
  organization: {
    organization_id: string;
    organization_name: string;
    organization_slug: string;
  };
  membership: {
    type: string;
    details: object | null;
  };
};

type OrganizationListItemProps = {
  organization: DiscoveredOrganization;
  isLoading: boolean;
  onJoin: (org: DiscoveredOrganization) => void;
};

const OrganizationListItem = ({
  organization,
  isLoading,
  onJoin,
}: OrganizationListItemProps): JSX.Element => {
  return (
    <li className="flex items-center justify-between rounded-lg border border-gray-200 bg-white p-3">
      <div className="flex items-center gap-3">
        <Building2 className="size-6 text-purple-600" />
        <span className="font-medium">{organization.organization.organization_name}</span>
      </div>
      <Button
        size="sm"
        onClick={() => onJoin(organization)}
        disabled={isLoading}
        className="bg-purple-600 text-white hover:bg-purple-700"
      >
        {isLoading && <Loader2 className="size-3 animate-spin" />}
        {isLoading ? "Uniendo..." : "Iniciar Sesión"}
      </Button>
    </li>
  );
};

export default OrganizationListItem;
